import React, { useState } from "react";
import CustomerMappingTab from "./quickbooks/CustomerMappingTab";
import AccountMappingTab from "./quickbooks/AccountMappingTab";

const TABS = [
  { key: "customers", label: "Customers" },
  { key: "accounts", label: "Accounts & tax" },
];

export default function QuickBooksMappingPage() {
  const [tab, setTab] = useState("customers");
  return (
    <div style={{ padding: 24 }}>
      <h1>QuickBooks mapping</h1>
      <div style={{ marginBottom: 16 }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              marginRight: 8,
              fontWeight: tab === t.key ? 700 : 400,
              borderBottom: tab === t.key ? "2px solid #3730a3" : "2px solid transparent",
            }}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "customers" ? <CustomerMappingTab /> : <AccountMappingTab />}
    </div>
  );
}
